import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { Campania } from '../_models/campania';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CampaniaService {

  private rutServicioCampania = AppSettings.rutServiciosAPL + '/api/campania';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoCampanias() {
    return this.httClient.get( this.rutServicioCampania ).pipe( map( res => res as Campania[] ) );
  }

  listadoCampaniasHabilitadas() {
    return this.httClient.get( this.rutServicioCampania + '/enabled' ).pipe( map( res => res as Campania[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicioCampania + '/' + id ).pipe( map( res => res as Campania ) );
  }

  crear( campania: Campania ) {
    campania.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioCampania, campania ).pipe( map( res => res as Campania ) );
  }

  actualizar( campania: Campania ) {
    campania.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioCampania, campania ).pipe( map( res => res as any ) );
  }


}
